// Colors defined at https://gallery.io/files/2fb4b52c21ea458390c0c1b139dee54d

module.exports = {
  blue: {
    100: '#E0E9F7',
    200: '#B9CEED',
    300: '#92B1E1',
    400: '#6B93D6',
    500: '#4878CB',
    600: '#2A5EC1',
    700: '#0250C5'
  },
  navy: {
    100: '#E1E4E7',
    200: '#B9C3C8',
    300: '#92A1A9',
    400: '#6B7E88',
    500: '#485E6C',
    600: '#274150',
    700: '#052A3E',
    active: '#04141C'
  },
  'logo-blue': {
    100: '#D4DAE3',
    200: '#AEBCD1',
    300: '#889EBF',
    400: '#6581B0',
    500: '#43659E',
    600: '#264A8E',
    700: '#052A3E'
  },
  'blue-gray': {
    100: '#EFF2F3',
    200: '#DBE1E4',
    300: '#C5CFD3',
    400: '#B0BCC2',
    500: '#9CACB3',
    600: '#889BA4',
    700: '#052A3E'
  },
  green: {
    100: '#E1F5EC',
    200: '#BAE7D4',
    300: '#92D9BA',
    400: '#6BCAA1',
    500: '#4ABC8A',
    600: '#2DAE72',
    700: '#00AB63'
  },
  'light-blue': {
    100: '#FDFEFF',
    200: '#FAFDFF',
    300: '#F7FBFF',
    400: '#F4F9FF',
    500: '#F1F8FF',
    600: '#EEF7FE',
    700: '#EEF7FF'
  },
  'alert-red': {
    100: '#FCE9EB',
    200: '#FACCD3',
    300: '#F7AEB8',
    400: '#F4909E',
    500: '#F27586',
    600: '#EE5B6E',
    700: '#EEF7FF'
  },
  'orange-yellow': {
    100: '#FAF6E5',
    200: '#F6E9C2',
    300: '#F0DC9E',
    400: '#E9CE7C',
    500: '#E4C25E',
    600: '#DEB544',
    700: '#E0B218'
  },
  'super-light-blue': {
    100: '#FAF6E5',
    200: '#F6E9C2',
    300: '#F0DC9E',
    400: '#E9CE7C',
    500: '#E4C25E',
    600: '#DEB544',
    700: '#FCFDFF'
  },
  'medium-gray': {
    100: '#F3F3F3',
    200: '#E3E3E3',
    300: '#D4D4D4',
    400: '#C3C3C3',
    500: '#B4B4B4',
    600: '#A3A3A3',
    700: '#959595'
  },
  'light-gray': {
    100: '#FCFBFC',
    200: '#F9F9F9',
    300: '#F6F6F6',
    400: '#F1F1F1',
    500: '#EEEEEE',
    600: '#EAEAEA',
    700: '#E7E7E7'
  },
  'super-light-gray': {
    100: '#FEFEFE',
    200: '#FEFEFE',
    300: '#FDFDFD',
    400: '#FCFBFC',
    500: '#FCFBFC',
    600: '#F9F9F9',
    700: '#FAFAFA'
  },
  gray: '#7F95A0'
}
